import { useMemo } from 'react'
import { ReactComponent as BinIcon } from './assets/bin-2.svg'

import Button from './Button'
import './Filter.scss'
import { DateRangePicker } from './ReportBuilder/form'

/**
 * @param {import('./Filter.types').FilterProps} props
 */
export const Filter = ({
  config = {},
  value = { type: undefined, value: [] },
  onChange = (value) => {},
  onRemove = () => {}
}) => {
  const valueOptions = useMemo(
    () =>
      config[value.type]?.list?.map(({ label, value }, index) => ({
        label,
        value
      })),
    [config, value]
  )
  const typeOptions = useMemo(
    () =>
      Object.entries(config).map(([type, { title }], index) => ({
        label: title,
        value: type
      })),
    [config]
  )

  /**
   * Paints the correct filter based on the type.
   */
  const PaintFilter = useMemo(() => {
    const filterConfig = config[value.type]

    switch (filterConfig?.style) {
      case 'date':
        return (
          <p className='filter-date-inputs'>
            <DateRangePicker
              from={value?.value?.[0]}
              onChangeFrom={(e) => {
                onChange({
                  ...value,
                  value: [e.target.value, value?.value?.[1]]
                })
              }}
              to={value?.value?.[1]}
              onChangeTo={(e) => {
                onChange({
                  ...value,
                  value: [value?.value?.[0], e.target.value]
                })
              }}
            />
          </p>
        )
      case 'list':
        return (
          <div className='form-item form-select'>
            <label>
              <div className='select-wrapper'>
                <select
                  name='filter-value'
                  value={value?.value || ''}
                  onChange={(e) => {
                    onChange({
                      ...value,
                      value: e.target.value
                    })
                  }}
                >
                  <option value={''} disabled>
                    Please select a filter value.
                  </option>
                  {valueOptions.map(({ label, value: opvalue }) => {
                    return (
                      <option key={label} value={opvalue}>
                        {label}
                      </option>
                    )
                  })}
                </select>
              </div>
            </label>
          </div>
        )
      default:
        return <></>
    }
  }, [onChange, config, value, valueOptions])

  return (
    <div className='filter'>
      <div className='inputs'>
        <div className='filter-type'>
          <div className='form-item form-select'>
            <div className='select-wrapper'>
              <label>
                <div className='select-wrapper'>
                  <select
                    name='filter-type'
                    value={value?.type || ''}
                    onChange={(e) => {
                      onChange({ type: e.target.value })
                    }}
                  >
                    <option value={''} disabled>
                      Please select a filter type.
                    </option>
                    {typeOptions.map(({ label, value: opvalue }) => {
                      return (
                        <option key={label} value={opvalue}>
                          {label}
                        </option>
                      )
                    })}
                  </select>
                </div>
              </label>
            </div>
          </div>
          <Button onClick={onRemove} type='primary'>
            <BinIcon />
          </Button>
        </div>
        {config[value.type] && <div className='filter-value'>{PaintFilter}</div>}
      </div>
    </div>
  )
}
